var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6306 0L0 5.89067V10.6669L11.6306 5.57226L22 10.6669V5.89067L11.6306 0Z",
    fill: "#F22B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6306 9.33203L0 15.2227V19.9989L11.6306 14.9043L22 19.9989V15.2227L11.6306 9.33203Z",
    fill: "#594AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankIcon);
export default __webpack_public_path__ + "static/media/rank_icon.4022089e4355fdd9101f749e981d6e48.svg";
export { ForwardRef as ReactComponent };